import script from "./ThirdMikatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdMikatPage.vue?vue&type=script&setup=true&lang=js"

import "./ThirdMikatPage.vue?vue&type=style&index=0&id=783e84f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783e84f0"]])

export default __exports__